import { ShoppingCart, Leaf, TrendingUp, Award, Users, Shield } from "lucide-react";
import { useTranslation } from "../i18n/LanguageContext";

const ExpertiseSection = () => {
  const { t } = useTranslation();

  const gmsFeatures = [
    { icon: ShoppingCart, title: t("gms_f1_title"), desc: t("gms_f1_desc") },
    { icon: TrendingUp, title: t("gms_f2_title"), desc: t("gms_f2_desc") },
    { icon: Users, title: t("gms_f3_title"), desc: t("gms_f3_desc") },
  ];

  const agroFeatures = [
    { icon: Leaf, title: t("agro_f1_title"), desc: t("agro_f1_desc") },
    { icon: Shield, title: t("agro_f2_title"), desc: t("agro_f2_desc") },
    { icon: Award, title: t("agro_f3_title"), desc: t("agro_f3_desc") },
  ];

  return (
    <section id="expertise" className="py-24 bg-[#131B2F]" data-testid="expertise-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-sm uppercase tracking-[0.3em] text-[#00CCC2] mb-4">{t("expertise_label")}</p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            <span className="gradient-text">{t("expertise_title")}</span>
          </h2>
          <p className="mt-4 text-slate-400 max-w-2xl mx-auto">{t("expertise_subtitle")}</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          <div className="p-8 rounded-3xl bg-[#0B1121] border border-white/10 card-hover">
            <div className="flex items-center gap-4 mb-6">
              <div className="p-4 rounded-2xl bg-gradient-to-br from-[#00CCC2]/20 to-[#4766FF]/20">
                <ShoppingCart className="w-8 h-8 text-[#00CCC2]" />
              </div>
              <div>
                <h3 className="text-2xl font-bold">{t("gms_title")}</h3>
                <p className="text-slate-400">{t("gms_subtitle")}</p>
              </div>
            </div>
            <p className="text-slate-300 mb-6">{t("gms_desc")}</p>
            <div className="space-y-4">
              {gmsFeatures.map((feature, i) => (
                <div key={i} className="flex items-start gap-4 p-4 rounded-xl bg-[#131B2F]/50">
                  <feature.icon className="w-5 h-5 text-[#00CCC2] mt-0.5" />
                  <div>
                    <h4 className="font-medium">{feature.title}</h4>
                    <p className="text-sm text-slate-400">{feature.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="p-8 rounded-3xl bg-[#0B1121] border border-white/10 card-hover">
            <div className="flex items-center gap-4 mb-6">
              <div className="p-4 rounded-2xl bg-gradient-to-br from-[#00CCC2]/20 to-[#4766FF]/20">
                <Leaf className="w-8 h-8 text-[#00CCC2]" />
              </div>
              <div>
                <h3 className="text-2xl font-bold">{t("agro_title")}</h3>
                <p className="text-slate-400">{t("agro_subtitle")}</p>
              </div>
            </div>
            <p className="text-slate-300 mb-6">{t("agro_desc")}</p>
            <div className="space-y-4">
              {agroFeatures.map((feature, i) => (
                <div key={i} className="flex items-start gap-4 p-4 rounded-xl bg-[#131B2F]/50">
                  <feature.icon className="w-5 h-5 text-[#00CCC2] mt-0.5" />
                  <div>
                    <h4 className="font-medium">{feature.title}</h4>
                    <p className="text-sm text-slate-400">{feature.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExpertiseSection;
